import React from 'react'

const AllCategories = () => {
  return (
    <div>
      <div className="no-categories-found">
        <span className="record-not-found">No Record found</span>
      </div>
    </div>
  );
}

export default AllCategories